import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslationService } from '../../../core/i18n';
import { prepareUrlForLink } from '../../../core/util';

@Injectable({ providedIn: 'root' })
export class AddonRedirectGuard {
  constructor(private router: Router, private translationService: TranslationService) {}

  canActivate(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<UrlTree | boolean> {
    return this.translationService.translate('common.url.addonKeyword_hint').pipe(
      map((value) => {
        const url = routerState.url.replace('/c', `/${value || 'catalog'}`);
        return this.router.parseUrl(prepareUrlForLink(url, route.queryParams));
      })
    );
  }
}
